import { useEffect } from "react";
import { JOB_STATUS_COMPLETED } from "~/constants/job";
import { useAppDispatch, useAppSelector } from "~/hooks";
import { PAGES } from "~/constants";
import { useHistory } from "react-router-dom";
import orderBy from "lodash/orderBy";
import { useSearchParams } from "~/utils/helpers/react-router-helper";

export function WelcomePage() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [searchParams, setSearchParams] = useSearchParams();
  const isNewHs = searchParams.get("is_new_hs");
  const isUpsellFlow = searchParams.get("type") === "upsell";
  const upsellJobId = searchParams.get("job_id");
  const jobData = useAppSelector(state => state.dashboard.jobData);
  const pendingJobId = useAppSelector(state => state.dashboard.jobId);
  const user = useAppSelector(state => state.auth.currentUser || {});
  useEffect(() => {
    // Handle upsell flow first
    if (isUpsellFlow && upsellJobId) {
      history.push(`${PAGES.SELECT_STYLES}?type=upsell&job_id=${upsellJobId}`);
      return () => {};
    }

    if (isNewHs) {
      if (pendingJobId) {
        history.push(PAGES.SELECT_STYLES);
      } else {
        history.push(PAGES.SELECT_PACKAGES);
      }
      return () => {};
    }
    if (pendingJobId) {
      history.push(PAGES.SELECT_STYLES);
      return () => {};
    }
    const uncompletedJob = jobData.find(job => job.status !== JOB_STATUS_COMPLETED);
    if (uncompletedJob) {
      history.push(PAGES.VIEW_RESULTS);
      return () => {};
    }
    const latestCompletedJob = orderBy(jobData, ["created_at"], ["desc"]).find(
      job => job.status === JOB_STATUS_COMPLETED
    );
    if (latestCompletedJob) {
      history.push(`${PAGES.RESULT_DETAIL}/${latestCompletedJob.id}`);
      return () => {};
    }
    if (user.is_all_access_plan) {
      history.push(PAGES.VIEW_RESULTS);
      return () => {};
    }
    history.push(PAGES.SELECT_PACKAGES);

    return () => {};
  }, [user, history, isNewHs, jobData, pendingJobId, isUpsellFlow, upsellJobId]);

  return null;
}
